<template>
    <div class="bottom">
        <ul v-show="menuShow">
            <li>
                <img
                    src="../../../../assets/image/index/left.png"
                    alt="前一个"
                />
            </li>
            <li
                @click="changeSystem(item)"
                v-for="item in userInfo.sys_codes"
                :key="item.sys_code"
            >
                <a>
                    <template>
                        <div
                            :class="
                                item.sys_code == activeSys ? 'currentSys' : ''
                            "
                        >
                            {{ item.sys_code_name }}
                        </div>
                        <img
                            :src="
                                item.sys_code == activeSys
                                    ? item.selectImg
                                    : item.img
                            "
                        />
                    </template>
                    <!-- <template v-if="item.sys_code == '10'">
                        <img
                            src="../../../../assets/image/index/bb1.png"
                            alt="总览首页"
                            v-show="menuType == 10"
                        />
                        <img
                            src="../../../../assets/image/index/b1.png"
                            alt="总览首页"
                            v-show="menuType != 10"
                        />
                    </template>
                    <template v-if="item.sys_code == '20'">
                        <img
                            src="../../../../assets/image/index/bb3.png"
                            alt="能效分析"
                            v-show="menuType == 20"
                        />
                        <img
                            src="../../../../assets/image/index/b3.png"
                            alt="能效分析"
                            v-show="menuType != 20"
                        />
                    </template>
                    <template v-if="item.sys_code == '30'">
                        <img
                            src="../../../../assets/image/index/bb5.png"
                            alt="配电监控"
                            v-show="menuType == 30"
                        />
                        <img
                            src="../../../../assets/image/index/b5.png"
                            alt="配电监控"
                            v-show="menuType != 30"
                        />
                    </template>
                    <template v-if="item.sys_code == '40'">
                        <img
                            src="../../../../assets/image/index/a2.png"
                            alt="电能质量"
                            v-show="menuType == 40"
                        />
                        <img
                            src="../../../../assets/image/index/a22.png"
                            alt="电能质量"
                            v-show="menuType != 40"
                        />
                    </template>
                    <template v-if="item.sys_code == '43'">
                        <img
                            src="../../../../assets/image/index/qjny_y.png"
                            alt="清洁能源"
                            v-show="menuType === 10"
                        />
                        <img
                            src="../../../../assets/image/index/qjny_b.png"
                            alt="清洁能源"
                            v-show="menuType !== 10"
                        />
                    </template>
                    <template v-if="item.sys_code == '47'">
                        <img
                            src="../../../../assets/image/index/jnjp_y.png"
                            alt="节能减排"
                            v-show="menuType === 11"
                        />
                        <img
                            src="../../../../assets/image/index/jnjp_b.png"
                            alt="节能减排"
                            v-show="menuType !== 11"
                        />
                    </template>
                    <template v-if="item.sys_code == '50'">
                        <img
                            src="../../../../assets/image/index/bb4.png"
                            alt="系统配置"
                            v-show="menuType == 50"
                        />
                        <img
                            src="../../../../assets/image/index/b4.png"
                            alt="系统配置"
                            v-show="menuType != 50"
                        />
                    </template>
                    <template v-if="item.sys_code == '60'">
                        <img
                            src="../../../../assets/image/index/bb6.png"
                            alt="储能监控"
                            v-show="menuType === 6"
                        />
                        <img
                            src="../../../../assets/image/index/b6.png"
                            alt="储能监控"
                            v-show="menuType !== 6"
                        />
                    </template>
                    <template v-if="item.sys_code == '70'">
                        <img
                            src="../../../../assets/image/index/bb23.png"
                            alt="运维管理"
                            v-show="menuType === 7"
                        />
                        <img
                            src="../../../../assets/image/index/b23.png"
                            alt="运维管理"
                            v-show="menuType !== 7"
                        />
                    </template>
                    <template v-if="item.sys_code == '80'">
                        <img
                            src="../../../../assets/image/index/bb8.png"
                            alt="消防监控"
                            v-show="menuType === 8"
                        />
                        <img
                            src="../../../../assets/image/index/b8.png"
                            alt="消防监控"
                            v-show="menuType !== 8"
                        />
                    </template>
                    <template v-if="item.sys_code == '75'">
                        <img
                            src="../../../../assets/image/index/bb9.png"
                            alt="空调监控"
                            v-show="menuType === 9"
                        />
                        <img
                            src="../../../../assets/image/index/b9.png"
                            alt="空调监控"
                            v-show="menuType !== 9"
                        />
                    </template>-->
                </a>
            </li>
            <li>
                <!-- <a href="#"> -->
                <img
                    src="../../../../assets/image/index/right.png"
                    alt="后一个"
                />
                <!-- </a> -->
            </li>
        </ul>
        <div @click="toggleMenu()" class="toggleIcon">
            <i class="iconfont icon-Arrowdown1" v-if="menuShow"></i>
            <i class="iconfont icon-Arrowup1" v-else></i>
        </div>
        <!-- <div class="bottom-name">北京麦克奥迪能源技术有限公司技术支持</div> -->
    </div>
</template>
<script>
export default {
    components: {},
    data() {
        return {
            activeSys: "", // 当前系统
            menuShow: true
        };
    },
    props: {
        menuType: String
    },
    computed: {
        userInfo() {
            let activeSys = sessionStorage.getItem("activeSys");
            if (activeSys) {
                this.activeSys = activeSys;
            } else {
                this.activeSys =
                    this.$store.state.login.userInfo.sys_codes &&
                    this.$store.state.login.userInfo.sys_codes[0].sys_code;
                sessionStorage.setItem("activeSys", this.activeSys);
            }

            return this.$store.state.login.userInfo;
        }
    },
    watch: {
        menuType: {
            handler(newValue) {
                this.menuType = sessionStorage.getItem("activeSys");
            },
            deep: true,
            immediate: true
        }
    },
    methods: {
        routerGo(url) {
            this.$router.push(url);
        },
        /**
         * 切换系统
         */
        changeSystem(sysObject) {
            if (
                this.$store.state.login.userInfo &&
                this.$store.state.login.userInfo.user_type == "99"
            ) {
                // this.$parent.setMenuTimer();
                return;
            }
            // 临时的
            if (sysObject.sys_code == "80") {
                // 空调管理
                this.$router.push("/air_condition");
                this.activeSys = "80";
                sessionStorage.setItem("activeSys", "80");
                sessionStorage.removeItem("activeTab");
                this.$store.commit("IS_CHANGE_SYSTEM", true);
                return;
            } else if (sysObject.sys_code == "90") {
                // 消防管理
                this.$router.push("/fire_control");
                this.activeSys = "90";
                sessionStorage.setItem("activeSys", "90");
                sessionStorage.removeItem("activeTab");
                this.$store.commit("IS_CHANGE_SYSTEM", true);
                return;
            }

            this.activeSys = sysObject.sys_code;
            sessionStorage.setItem("activeSys", this.activeSys);
            sessionStorage.removeItem("activeTab");
            sessionStorage.removeItem("header-title");
            this.$store.commit("IS_CHANGE_SYSTEM", true);
            this.$store.dispatch("getMenuListByRoles", this.activeSys);
        },
        toggleMenu() {
            this.menuShow = !this.menuShow;
        }
    }
};
</script>
<style lang="scss">
.bottom ul {
    text-align: center;
    position: fixed;
    bottom: 0;
    left: 50%;
    transform: translate(-50%, 0);
    width: 100%;
}
.bottom ul li {
    display: inline-block;
}
.bottom {
    position: fixed;
    bottom: 0px;
    padding-bottom: 30px;
    left: 0;
    clear: both;
    // height: 60px;
    width: 100%;
    // background: url(../../../../assets/image/index/bottom.png) no-repeat
    //     bottom center;
    // z-index: 9999999;
}
.bottom ul li a {
    display: block;
}
.bottom ul li a > div {
    font-size: px2Rem(16px);
    height: px2Rem(20px);
    line-height: px2Rem(20px);
    color: #56fcff;
    font-family: "Trebuchet MS", "Lucida Sans Unicode", "Lucida Grande",
        "Lucida Sans", Arial, sans-serif;
    // text-shadow: px2Rem(0.5px) px2Rem(0.5px) px2Rem(0.5px) #56fcff;
}
.currentSys {
    color: #ffb728 !important;
    // text-shadow: px2Rem(0.5px) px2Rem(0.5px) px2Rem(0.5px) #ffb728;
}
.bottom ul li a > img {
    width: px2Rem(110px);
    height: px2Rem(80px);
}
.bottom-name {
    position: absolute;
    right: 20px;
    color: #56fcff;
    top: 10px;
}
.toggleIcon {
    position: fixed;
    bottom: px2Rem(20px);
    right: px2Rem(20px);
    cursor: pointer;
    color: #fff;
    i {
        font-size: px2Rem(30px);
    }
}
</style>
